<template>
    <el-dialog
            title="添加部门"
            :close-on-click-modal="false"
            :visible="addData.state"
            width="480px"
            :modal="false"
            @close="closeModal()"
    >
        <div style="padding-right: 20px">
            <el-form :model="formValidate" :rules="ruleValidate" ref="ruleForm" label-width="100px"
                     class="demo-ruleForm">
                <el-form-item label="上级部门">
                    <el-input disabled v-model="formValidate.parenNode"></el-input>
                </el-form-item>
                <el-form-item label="部门名称" prop="name">
                    <el-input v-model="formValidate.name"></el-input>
                </el-form-item>
                <el-form-item label="部门编码" prop="deptCode">
                    <el-input v-model="formValidate.deptCode" ></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model.number="formValidate.sort" controls-position="right" :min="1" step-strictly></el-input-number>
                </el-form-item>
                <!-- <el-form-item label="教学单位" prop="region">
                    <el-select v-model="formValidate.teachUnit" placeholder="是否为教学单位" style="width: 100%">
                        <el-option v-for="item in teachUnit" :value="item.value" :key="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="机构层级" prop="orgLevel">
                    <el-select v-model="formValidate.orgLevel" style="width: 100%">
                        <el-option v-for="item in orgLevel" :value="item.value" :key="item.value"
                                   :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否诊改" prop="orgLevel">
                    <el-radio-group v-model="formValidate.joinHie">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item> -->
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
             <el-button type="primary" @click="submitForm('ruleForm')" :disabled="subDisabled">确 认</el-button>
            <el-button @click="resetForm('ruleForm')">重 置</el-button>

        </span>
    </el-dialog>
</template>

<script>
    import {addDept} from '@/api/admin/dept';

    export default {
        props: {
            addData: {
                type: Object,
                required: true
            }
        },
        components: {},
        data() {
            var checkDept = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('部门编码不能为空'));
                }
                if (isNaN(value)) {
                    callback(new Error('请输入数字值'));
                }else{
                    callback();
                }
            };
            return {
                subDisabled: false,
                ruleForm: {},
                orgLevel: [
                    {value: '1', label: '校级'},
                    {value: '2', label: '院系'},
                    {value: '3', label: '专业'},
                    {value: '4', label: '班级'}
                ],
                teachUnit: [
                    {value: '1', label: '是'},
                    {value: '0', label: '否'}
                ],
                formValidate: {
                    parenNode: '',
                    nodeNum: '',
                    name: '',
                    detId: '',
                    teachUnit: 1,
                    orgLevel: 1,
                    sort: 1,
                    joinHie: 1,
                    deptCode: '',
                }, // 表单数据绑定
                ruleValidate: {
                    name: [
                        {required: true, message: '部门名称不能为空', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    deptCode: [
                        {validator: checkDept,required: true, trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                }, // 表单验证
            };
        },
        computed: {},
        methods: {
            showAddData() {
                this.formValidate.parenNode = this.addData.data.name;
                this.formValidate.depName = '';
                this.formValidate.parenNodeId = this.addData.data.id;
                this.formValidate.sort = 1;
                this.formValidate.teachUnit = 1;
                this.formValidate.orgLevel = 1;
                this.formValidate.joinHie = 1;
                this.formValidate.teachUnit = this.teachUnit[0].value;
                this.formValidate.orgLevel = this.orgLevel[0].value;
                // console.log(this.formValidate)
            },
            closeModal() {
                this.$emit("closeAdd", {state: false});
                this.addData.state = false;
                this.resetForm('ruleForm')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 新增
                        // let subForm = {
                        //     "name": this.formValidate.name,
                        //     "sort": this.formValidate.sort,
                        //     "deptCode": this.formValidate.deptCode,
                        //     "parentId": this.formValidate.parenNodeId,
                        //     "organType": this.formValidate.teachUnit,
                        //     "joinHie": this.formValidate.joinHie,
                        //     "organLevel": this.formValidate.orgLevel
                        // };
                        let subForm = {
                            "name": this.formValidate.name,
                            "parentId": this.formValidate.parenNodeId,
                            "sort": this.formValidate.sort,
                            "deptCode": this.formValidate.deptCode,
                        }
                        this.subDisabled = true;
                        addDept(subForm).then(res => {
                            this.subDisabled = false;
                            if (res.data.code == 0) {
                                this.formValidate = {
                                    parenNode: '',
                                    nodeNum: '',
                                    name: '',
                                    detId: '',
                                    teachUnit: 1,
                                    orgLevel: 1,
                                    sort: 1,
                                    joinHie: 1
                                }; // 表单数据绑定
                                this.closeModal();
                                // 重新获取组织部门树
                                this.$store.dispatch("getDeptTree").then((data) => {
                                    this.$store.commit("SET_CHOOSE_DEPT",data.data.data)
                                });
                                this.$store.dispatch("getStudentTree").then(() => {
                                });
                            } else {
                                this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning'
                                });
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                setTimeout(()=>{
                    this.formValidate.parenNode = this.addData.data.name;
                    this.formValidate.depName = '';
                    this.formValidate.parenNodeId = this.addData.data.id;
                    this.formValidate.sort = 1;
                    this.formValidate.teachUnit = 1;
                    this.formValidate.orgLevel = 1;
                    this.formValidate.joinHie = 1;
                    this.formValidate.teachUnit = this.teachUnit[0].value;
                    this.formValidate.orgLevel = this.orgLevel[0].value;
                },200)
            }
        }
    }
</script>

<style scoped>

</style>
